import React, { useEffect, useState } from 'react';
import { RefreshCw, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { AdminAPI } from '../../api';

const fmt = (ts) => (ts ? new Date(ts).toLocaleString() : '—');

export const UsersTable = () => {
  const [users, setUsers] = useState(null);
  const load = () => AdminAPI.users().then(setUsers).catch(() => { setUsers([]); toast.error('Failed to load users'); });
  useEffect(() => { load(); }, []);

  if (users === null) return <div className="text-[13px] text-[#6F76A7]">Loading…</div>;

  return (
    <div data-testid="admin-users">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="text-[13px] text-[#6F76A7]">{users.length} account{users.length === 1 ? '' : 's'} · newest activity first</p>
        <button onClick={load} className="inline-flex items-center gap-1.5 text-[13px] text-[#0A1551] hover:underline" data-testid="admin-users-refresh"><RefreshCw className="w-3.5 h-3.5" /> Refresh</button>
      </div>
      <div className="space-y-2 md:hidden">
        {users.map((u) => (
          <div key={u.user_id} className="bg-white border border-[#E3E5F5] rounded-xl p-3" data-testid={`admin-user-card-${u.user_id}`}>
            <div className="flex items-center gap-2">
              <span className="text-[14px] font-semibold text-[#0A1551] truncate">{u.name}</span>
              {u.is_admin && <ShieldCheck className="w-4 h-4 text-[#0F766E]" title="Admin" />}
              {u.session_active && <span className="ml-auto text-[11px] font-semibold text-[#0AA24F]">Active</span>}
            </div>
            <div className="text-[13px] text-[#6F76A7] truncate">{u.email}</div>
            <div className="text-[12px] text-[#9599C0] mt-1">Last login {fmt(u.last_login)} · {u.assets} assets · {u.teams} teams</div>
          </div>
        ))}
      </div>
      <div className="hidden md:block bg-white border border-[#E3E5F5] rounded-xl overflow-x-auto">
        <table className="w-full text-[13px]">
          <thead className="bg-[#F9FAFD] border-b border-[#E3E5F5] text-[11px] uppercase tracking-wide text-[#6F76A7]">
            <tr>
              <th className="text-left px-4 py-2.5 font-semibold">User</th>
              <th className="text-left px-4 py-2.5 font-semibold">Last login</th>
              <th className="text-left px-4 py-2.5 font-semibold">Session</th>
              <th className="text-right px-4 py-2.5 font-semibold">Assets</th>
              <th className="text-right px-4 py-2.5 font-semibold">Trash</th>
              <th className="text-right px-4 py-2.5 font-semibold">Teams</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-b border-[#F0F1FB] last:border-0" data-testid={`admin-user-row-${u.user_id}`}>
                <td className="px-4 py-3 min-w-0">
                  <div className="flex items-center gap-1.5 font-semibold text-[#0A1551]">{u.name}{u.is_admin && <ShieldCheck className="w-3.5 h-3.5 text-[#0F766E]" />}</div>
                  <div className="text-[12px] text-[#6F76A7]">{u.email}</div>
                </td>
                <td className="px-4 py-3 text-[#4A517D] whitespace-nowrap">{fmt(u.last_login)}</td>
                <td className="px-4 py-3">{u.session_active ? <span className="text-[12px] font-semibold text-[#0AA24F]">Active</span> : <span className="text-[12px] text-[#9599C0]">Signed out</span>}</td>
                <td className="px-4 py-3 text-right text-[#0A1551] font-medium">{u.assets}</td>
                <td className="px-4 py-3 text-right text-[#6F76A7]">{u.trashed}</td>
                <td className="px-4 py-3 text-right text-[#6F76A7]">{u.teams}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTable;
